import { render, staticRenderFns } from "./RouterLinks.vue?vue&type=template&id=022cfaba&scoped=true&"
import script from "./RouterLinks.vue?vue&type=script&lang=js&"
export * from "./RouterLinks.vue?vue&type=script&lang=js&"
import style0 from "./RouterLinks.vue?vue&type=style&index=0&id=022cfaba&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022cfaba",
  null
  
)

export default component.exports